export var IDBNames;
(function (IDBNames) {
    IDBNames["ExploreStates"] = "explore-states";
    IDBNames["WarmTier"] = "warm-tier";
    // No app in THIS repo creates this DB anymore (app-orioniq was removed), but the OrionIQ standalone
    // served at /orioniq shares an origin with the main app and may still persist under it. This enum is
    // the deny-by-default allowlist for `removeForbiddenIDBDbs`, which deletes every IndexedDB on the
    // origin whose name is absent here — and it runs on login. A stale entry only ever prevents a
    // deletion, so keeping it is free; dropping it silently wipes that app's panel/tab state and chat
    // cache on the next main-app login. Remove only once /orioniq is confirmed not to use this name.
    IDBNames["OrionIq"] = "orioniq";
    IDBNames["OrionIq360"] = "orioniq-360";
})(IDBNames || (IDBNames = {}));
//# sourceMappingURL=indexed-db-names.js.map